<template>
  <div class="main-content">
    <TabelaArtes/>
    <TabelaEnvios class="mt-5"/>
  </div>
</template>

<script>
import TabelaArtes from '@/views/app/crm/controledeartes/tabelaartes'
import TabelaEnvios from '@/views/app/crm/controledeartes/tabelaenvios'

export default {
  components: {
    TabelaArtes,
    TabelaEnvios
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
